import { isBrowser } from '@app/utils/isBrowser'

declare global {
  interface Window {
    ga: any
  }
}

// https://developers.google.com/optimize/devguides/experiments
export const setExperimentAndVariantId = (experimentId: string, variationId: string) => {
  if (!isBrowser || !window.ga) return
  window.ga('set', 'exp', `${experimentId}.${variationId}`)
}

export const sendAction = (action: string) => {
  if (!isBrowser || !window.ga) return
  window.ga('send', action)
}
